export default class ItemIdsObserver {
  constructor(context) {
    this.context = context;
  }

  onBroadcast() {}

  onBroadcastDelete() {}
}
